export const Svg_119 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m46.885 62.417-7.583-12.833h-9.188c-.632 0-1.154-.207-1.567-.62-.414-.413-.62-.936-.62-1.568s.206-1.154.62-1.567c.413-.414.935-.62 1.567-.62h9.188l7.583-12.834h1.823L44.916 45.21h9.625l2.188-2.917h1.604l-1.531 5.104 1.53 5.105H56.73l-2.188-2.917h-9.625l3.792 12.833h-1.823ZM21.291 37.626l3.792-12.834h-9.625L13.27 27.71h-1.604l1.531-5.104-1.53-5.105h1.603l2.188 2.917h9.625L21.29 7.584h1.823l7.584 12.833h9.187c.632 0 1.154.207 1.568.62.413.413.62.936.62 1.568s-.207 1.154-.62 1.567c-.414.413-.936.62-1.568.62h-9.187l-7.584 12.834h-1.823Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={50.15}
        y1={15.809}
        y2={53.951}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)